import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Header } from '@domain/interface/header';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-second-step',
	templateUrl: './second-step.component.html',
	styleUrls: ['./second-step.component.scss'],
})
export class SecondStepComponent implements OnInit {
	@Input() headers: any;
	@Input() expectedHeadersMap: Header[];
	@Input() formGroupObject: UntypedFormGroup;
	@Input() dataType: any = null;
	@Input() requiredHeaders: string[] = [];

	@Output() headersMapped: EventEmitter<string> = new EventEmitter();

	public headerMapFormGroup: UntypedFormGroup = null;
	public expectedHeaders: string[];
	public headersDropdownList = [];
	RFP_UPLOAD_TYPE = 'priceLane';
	PROJECT_TYPE: string = 'project';

	constructor(private utilService: UtilService) {}

	ngOnInit() {
		if (!this.utilService.isNullOrUndefined(this.expectedHeadersMap)) {
			this.expectedHeaders = this.expectedHeadersMap.map((expectedHeader: Header) => {
				return expectedHeader.value;
			});
		}
	}

	ngAfterViewInit() {
		// this.headers = headerArray.split(',');
		if (!this.utilService.isNullOrUndefined(this.formGroupObject)) {
			this.headerMapFormGroup = this.formGroupObject;
			this.populateFormGroup();
			this.updateControls();
			this.registerChangeListener();
		}
	}

	populateFormGroup() {
		let self = this;
		if (!this.utilService.isNullOrUndefined(this.headers)) {
			this.headers.forEach((header, index) => {
				// populating dropddown with existing headers
				self.headersDropdownList.push({
					label: header.trim(),
					index: index,
				});
				// assigning values to formControl for the respective matching headers
				let formattedHeader = header.toLowerCase().trim();
				if (self.expectedHeaders.indexOf(formattedHeader) >= 0) {
					self.headerMapFormGroup.patchValue({ [formattedHeader]: header });
				}
			});
			if (this.dataType === this.PROJECT_TYPE) {
				// additional project validations here
			} else {
				this.headerMapFormGroup.setValidators(this.isFormValid);
			}
			if (this.dataType == this.RFP_UPLOAD_TYPE && this.headerMapFormGroup.valid) {
				this.afterMapping();
			}
		}
	}

	updateControls() {
		Object.values(this.headerMapFormGroup.controls).forEach((control: UntypedFormControl) => {
			control.markAsTouched();
		});
	}

	registerChangeListener() {
		this.headerMapFormGroup.valueChanges.subscribe(() => {
			if (this.hasDuplicateMapping(this.headerMapFormGroup)) {
				this.utilService.showSnackbar('Header already mapped', SNACKBAR.ERROR, SNACKBAR.ACTION);
				if (this.dataType == this.PROJECT_TYPE) {
					this.headerMapFormGroup.setErrors({ duplicateMapping: true });
				}
			} else {
				if (this.dataType == this.PROJECT_TYPE) {
					this.headerMapFormGroup.setErrors(null);
				}
			}
		});
	}

	isFormValid(group: UntypedFormGroup) {
		// are all the headers mapped
		let isMapped = true;
		Object.values(group.controls).forEach((control: UntypedFormControl) => {
			if (!control.value) {
				isMapped = false;
			}
		});
		if (!isMapped) {
			return { missingHeader: true };
		}

		// has duplicate mapping
		let formGroupValues = Object.values(group.value);
		if (new Set(formGroupValues).size != formGroupValues.length) {
			return { duplicateMapping: true };
		}
		return null;
		// Note: I tried to put the above code in reusable methods, but had issues
		// injecting them inside form validator
	}

	hasDuplicateMapping(group: UntypedFormGroup): boolean {
		let formGroupValues = Object.values(group.value);
		if (this.dataType === this.PROJECT_TYPE) {
			formGroupValues = formGroupValues.filter((value: string) => value.length !== 0);
		}
		if (new Set(formGroupValues).size != formGroupValues.length) {
			return true;
		}
		return false;
	}

	afterMapping() {
		let self = this;
		Object.entries(this.headerMapFormGroup.value).forEach((entry: any) => {
			let key = entry[0],
				value = entry[1];
			if (self.expectedHeaders.indexOf(value.toLowerCase().trim()) < 0) {
				let index = self.headers.indexOf(value);
				self.headers[index] = self.getHeaderLabel(key);
			}
		});
		let headersRow = this.headers.join();
		this.headersMapped.emit(headersRow);
	}

	getHeaderLabel(value: string) {
		let resultArray = this.expectedHeadersMap.filter((header) => {
			return header['value'] == value;
		});
		let header = resultArray[0];
		return header['label'];
	}
}
